import { render, staticRenderFns } from "./ParticipantGroupsField.vue?vue&type=template&id=bad77f6c"
import script from "./ParticipantGroupsField.vue?vue&type=script&lang=js"
export * from "./ParticipantGroupsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports